import React, { Component } from 'react';
import { Control, LocalForm, Errors } from 'react-redux-form';
import PropTypes from 'prop-types';
import Header from '../Header';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import UserTable from './table';
import {Link} from "react-router-dom";
import ModalExample from "./pop";
import './styles.css';
import ModalExample2 from "./popaddexistinguser";
import ModalExample3 from "./popfooter";
import {getStore} from '../../../index';
import 'bootstrap/dist/css/bootstrap.min.css';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'datafactory.user.management',
    description: 'Page Header Title',
    defaultMessage: 'Data Factory Users Management'
  },
  headerSubTitle: {
    id: 'datafactory.user.management.subtitle',
    description: 'Page Header Subtitle',
    defaultMessage: 'Manage data factory users'
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

class ManagementDFuser extends Component {
  componentDidMount(){
   // alert(this.props.match.params.owner);
    console.log(this.props.match.dfid);
    
    
    console.log(this.props.role);
    this.setState({dfid:this.props.match.params.dfid});
    this.setState({dfactoryid:this.props.match.params.dfid});
    console.log(this.state);
    this.props.getuserlistnotindf(this.props.match.params.customerid,this.props.match.params.dfid);

   if(this.props.role.includes('SALESMAN_ENGINEER')  ||
        this.props.role.includes('PROFESSIONAL_SERVICE') ){
          this.props.getCustomerdfList(this.props.match.params.customerid);
          this.props.getUserListbydf(this.props.match.params.dfid);
    
     }else{

          this.props.getCustomerdfList(this.props.match.params.customerid); 
          this.props.getUserListbydf(this.props.match.params.dfid);  
      }
    
    //this.props.getalldfList();
   // this.setState({dfuserList:[]});
   //this.props.dfuserList=[];
  }

  constructor(props) {
    super(props);
    const { intl } = this.props;
    this.state = {
      showInvite: false,
      showInviteSent: false,
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      role: "",
      delUser: "",
      delEmail: "",
      delUserid:"",
      status: "",
      dfactoryid:"",
      customersList:[],
     dfuserList:[],
     userlistnotindf:[],
     dfuserid:"",
     dfid:"",
     newownerid:"",
     newownername:""
    // dfuserfromdropdown:""
    };
  }

  //  getuserlistnotindf = (customerid,dfid)=>{ 
  //   // getuserlistnotindf(customerid,dfid);
     
  //  };

    //confirmation =()=>{};
    confirmation = () => { }
   submitRequest = ()=>{
    // alert("ok");
    this.confirmation();
  }

  confirmationSubmit = ()=>{
    console.log(this.state.dfactoryid);
    this.props.removeusertodf(this.state.dfuserid,this.state.dfactoryid,this.props.match.params.customerid);
     this.setState({dfuserid:""});
    
    
    //this.props.getuserlistnotindf(this.props.match.params.customerid,this.state.dfactoryid);
    // .then((e)=> {
    //   this.props.getuserlistnotindf(this.state.dfactoryid);
    //   //  this.props.getUserListbydf(this.state.dfactoryid)
    //      }
    //   );
  
  }
   confirmationText = "Are you sure you want to remove the user?  <br /><br />"




   changenewowner= ()=>{
   
    this.props.changeowner(this.state.newownerid,this.state.newownername,this.state.dfactoryid)
  };


  selectUsersBydf =  (e)=>{
   // alert('ok');
   if(""== e.target.value){
    this.setState({dfactoryid : ""});
    return;
   }
    this.setState({dfactoryid : e.target.value});

   console.log( e.target.value);

   //this.props.getCustomerdfList(e.target.value,  this.setState({ dfs: [] }));
   this.props.getUserListbydf(e.target.value);//,this.setState({dfuserList:this.props.dfuserList}));

  this.setState({dfuserList:this.props.dfuserList});

  // this.props.getUserNotInListbydf(e.target.value);
  // this.setState({notdfuserList:this.props.notdfuserList});



  this.props.getuserlistnotindf(this.props.match.params.customerid,e.target.value);
  
  this.setState({userlistnotindf:this.props.userlistnotindf});
  console.log(this.state.userlistnotindf);
  };


  adduser  = (dfuserfromdropdown) => {
    console.log(dfuserfromdropdown);
    //this.setState({dfuserfromdropdown:dfuserfromdropdown});
   // this.props.addusertodf(dfuserfromdropdown,this.state.dfid)
    this.props.addusertodf(dfuserfromdropdown,this.state.dfactoryid)
    // .then((e)=> {
    //  // this.props.getuserlistnotindf(this.state.dfactoryid);
    //   //  this.props.getUserListbydf(this.state.dfactoryid)
    //      }
    //   );
    
 
  };

  showInviteTrue = () => {
    this.setState({ showInvite: true });
    messages.headerTitle = {
      id: 'user.invitation',
      description: 'Page Header Title',
      defaultMessage: 'User Invitation'
    };
  };
  showInviteFalse = () => {
    this.setState({ showInvite: false });
    messages.headerTitle = {
      id: 'user.management',
      description: 'Page Header Title',
      defaultMessage: 'User Management'
    };
  };

  sendInvite = () => {
    this.props.inviteUser(
      this.state.firstname,
      this.state.lastname,
      this.state.email,
      this.state.phone,
      this.props.username,
      this.state.role,
      this.invitedsent
    );
  }

  invitedsent = ()=>{
    this.setState({showInviteSent : true});
    messages.headerTitle = {
      id: 'user.invitation',
      description: 'Page Header Title',
      defaultMessage: 'Success'
    };
  }

  selectItem = (value)=>{
    console.log(value);
    this.setState({dfuserid:value.userid,newownerid:value.userid,newownername:value.username});
    console.log(this.state.dfuserid);
   // this.setState({delUser: value.username,status: value.status,delEmail: value.email})
  }
  openModal = ()=>{};

  confirmationText = "Are you sure you want to remove the user?  <br /><br />"


  render() {
    return (
      <div className="preview page">
        <Helmet>
          <title>
            {this.props.intl.formatMessage(messages.htmlHeader)} - FUSE
          </title>
        </Helmet>
        <Header
          title={this.props.intl.formatMessage(messages.headerTitle)}
          subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
          icon="preview"
          locale={this.props.locale}
          status = {this.props.status}
        />
        {/* <ModalExample
          hasTitle
          warning
          className="modal_sm"
          reset={()=>this.props.logout()}
          setClick={click => this.openModal = click}
          content={this.confirmationText}/> */}

         <ModalExample
          hasTitle
          confirmation
          infoText="Confirmation"
          className="modal_sm"
          reset={()=>{}}
          setClick={click => this.confirmation = click}
          confirmationSub = {this.confirmationSubmit}
          content={this.confirmationText}/>

        <div className="main">
          {this.state.showInvite &&(
            <div
              className="panel"
              style={{
                width: '92%',
                padding: '40px',
                boxSizing: 'content-box',
                marginTop: '15px',
                display: 'block',
                alignContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            >
              {this.state.showInviteSent &&(
                <div>
                  <label
                    style={{
                      width: '90%',
                      fontSize: '16px',
                      textTransform: 'none',
                      lineHeight: '150%'
                    }}
                  >
                    An invitation with temporary password has been sent to the user.
                  </label>
                  <br />
                  &nbsp;
                  <br />
                  &nbsp;
                  <div className="button-container" style={{ textAlign: 'center' }}>
                    <button
                      className="button"
                      styel={{ padding: 20 }}
                      type="button"
                      onClick={() => window.location.reload()}
                    >
                      <FormattedMessage id="nav.ok" defaultMessage="OK" />
                    </button>
                  </div>
                </div>
              )}

              {!this.state.showInviteSent &&(
                <LocalForm
                  className="form"
                  model="user"
                  onSubmit={this.sendInvite}
                >
                  <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="user.firstname.title"
                        defaultMessage="First Name: "
                      />
                    </label>
                    <Control.text
                      model="user.firstname"
                      value={this.state.firstname}
                      autoFocus
                      onChange={event=>{this.setState({firstname: event.target.value})}}
                    />
                  </fieldset>

                  <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="user.lastname.title"
                        defaultMessage="Last Name: "
                      />
                    </label>
                    <Control.text
                      model="user.lastname"
                      value={this.state.lastname}
                      autoFocus
                      onChange={event=>{this.setState({lastname: event.target.value})}}
                    />
                  </fieldset>

                  <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="assessment.request.translation.Email.name"
                        defaultMessage="Email: "
                      />
                    </label>

                    <Control.text
                      model="user.email"
                      value={this.state.email}
                      type="email"
                      autoFocus
                      required
                      onChange={event=>{this.setState({email: event.target.value})}}
                    />
                  </fieldset>

                  <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="telephone.label.name"
                        defaultMessage="Telephone"
                      />
                    </label>

                    <Control.text
                      model="user.phone"
                      value={this.state.phone}
                      autoFocus
                      onChange={event=>{this.setState({phone: event.target.value})}}
                    />
                  </fieldset>

                  <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="projects.user.role"
                        defaultMessage="Role: "
                      />
                    </label>
                   {this.props.role.includes("CUSTOMER_ADMIN")&& (
                    <Control.select
                      model="user.role"
                      defaultValue={this.state.role}
                      autoFocus
                      required
                      onChange={event=>{this.setState({role: event.target.value})}}
                    >
                      <option value="">Please select one role</option>
                      <option value="PROFESSIONAL_SERVICE">User</option>
                      
                    </Control.select>
                    )}
                     {!this.props.role.includes("CUSTOMER_ADMIN")&& (
                    <Control.select
                      model="user.role"
                      defaultValue={this.state.role}
                      autoFocus
                      required
                      onChange={event=>{this.setState({role: event.target.value})}}
                    >
                      <option value="">Please select one role</option>
                      <option value="PROFESSIONAL_SERVICE">User</option>
                      
                    </Control.select>
                    )}
                  </fieldset>

                  <div className="button-container" style={{ textAlign: 'center' }}>

                    <button
                      className="button"
                      type="submit"
                      onClick={()=>{this.showInviteFalse();this.props.getusersList(this.props.username);} }
                      style={{ marginRight: '40px' }}
                    >
                      <FormattedMessage
                        id="run-assessment.back.button.name"
                        textTransform="capitalize"
                        defaultMessage="Back"
                      />
                    </button>


                    <button
                      className="button"
                      type="submit"
                    >
                      <FormattedMessage
                        id="submit.button.name"
                        defaultMessage="Submit"
                      />
                    </button>
                  </div>
                </LocalForm>
              )}

            </div>

          )}

         {!this.state.showInvite && (<div
              className="panel"
              style={{
                width: '95%',
                padding: '40px,40px,0,40px',
                boxSizing: 'content-box',
                marginTop: '15px',
                display: 'block',
                alignContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            >
             <div
                  className="form"
                  //model="user"
                 // onSubmit={this.sendInvite}
                >
                    <fieldset style={{padding: '20px', width: "auto", float:"none"}}>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="data.factory.name"
                        defaultMessage="data factory name: "
                      />
                    </label>
                    <Control.select
                      model=".dfactoryid"
                      value={this.state.dfactoryid}
                      autoFocus
                      required
                     // onChange={event=>{this.setState({dfactoryid: event.target.value})}}
                      onChange={this.selectUsersBydf}
                    >

                        <option value="">Please select data factory</option>
                            {this.props.customerdfList.map(item => (
                              <option key={item["dfid"]} value={item["dfid"]}>
                                {item["reponame"]}
                              </option>
                            ))}
                      {/* <option value="">Please select data factory</option>
                      <option value="Test">Test</option> */}
                    </Control.select>
                  </fieldset>
                 {this.props.dfuserList.length > 0 && (
                 <UserTable data={this.props.dfuserList} selectItem={this.selectItem}
                 deleteUser={this.props.match.params.owner}  username={this.props.username}/>

                 )}
                    <br/><br/>
                  <div
                    className="button-container"
                    style={{ textAlign: 'center',marginBottom:'20px' }}
                  >

                      <Link to="/en-CA/datafactorymanagement">
                                        <button
                                          className="button"
                                          style={{ marginRight: '40px' }}
                                          type="button"
                                          // onClick={() => this.props.clickBackHandler()}
                                        >
                                          <FormattedMessage
                                            id="run-assessment.back.button.name"
                                            defaultMessage="Back"
                                          />
                                        </button>
                                      </Link>

                                      <button
                                       className="button"   disabled={this.state.dfactoryid == ""}>
                                        <ModalExample3
                                            hasTitle
                                            info
                                            infoText="Select source code staging project names:"
                                            className="modal_md"
                                            dfuserList={this.props.dfuserList}
                                            userlistnotindf={this.props.userlistnotindf}
                                            callback={this.adduser}
                                           // dfuserfromdropdown={this.state.dfuserfromdropdown}
                                          //  setState={this.setState}
                                            // setDfuserfromdropdown={this.setState()}
                                          //  getuserlistnotindf = {this.getuserlistnotindf(this.state.dfactoryid)}
                                          //  repos = {this.username}
                                          // changeStagingprj ={repoCallback}
                                            buttonLabel = "Add User"
                                          //  setRepos = {setRepo}

                                        >

                                        </ModalExample3>

                                </button>

                                  <button disabled={this.state.dfactoryid == "" || !this.props.role.includes('PROFESSIONAL_SERVICE')}
                                    className="button"
                                    style={{ marginRight: '40px',marginLeft:'52px' }}
                                    type="button"
                                    onClick={this.showInviteTrue}
                                  >
                                    <FormattedMessage
                                      id="management.invite"
                                      defaultMessage="INVITE USER"
                                    />
                                  </button>

                                  <button disabled={this.state.dfuserid == ""}
                                        className="button"
                                        style={{ marginRight: '40px' }}
                                        type="button"
                                        // onClick={()=>this.props.deleteUser(this.state.delUser,this.state.delEmail,this.props.username,this.props,this.selectItem)}
                                        //disabled={this.state.delUser === "" || this.state.status === "DELETED"}
                                        //onClick={()=>this.props.removeDfUser(this.state.dfuserid,this.state.dfactoryid)}
                                        onClick={this.changenewowner}
                                      >
                                        <FormattedMessage
                                          id="projects.project.changeowner"
                                          defaultMessage="CHANGE OWNER"
                                        />
                                      </button>

                                      <button disabled={this.state.dfuserid === "" || !this.props.role.includes('PROFESSIONAL_SERVICE')}
                                        className="button"
                                        style={{ marginRight: '40px' }}
                                        type="button"
                                        // onClick={()=>this.props.deleteUser(this.state.delUser,this.state.delEmail,this.props.username,this.props,this.selectItem)}
                                        //disabled={this.state.delUser === "" || this.state.status === "DELETED"}
                                        //onClick={()=>this.props.removeDfUser(this.state.dfuserid,this.state.dfactoryid)}
                                        onClick={this.submitRequest}
                                      >
                                        <FormattedMessage
                                          id="projects.project.removeuser"
                                          defaultMessage="REMOVE USER"
                                        />
                                      </button>



                  </div>

              </div>
               {/* </LocalForm> */}
            </div> )
            }


          {/* {!this.state.showInvite && (
            <div
              className="panel"
              style={{
                width: '60%',
                padding: '40px',
                boxSizing: 'content-box',
                marginTop: '15px',
                display: 'block',
                alignContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            > */}

              {/* <UserTable data={this.props.usersList} selectItem={this.selectItem}  username={this.props.username}/> */}

              <br/>
              <br/>
              {/* <div style={{ float: ' ',height:'44px',marginLeft:'400px',marginBottom:'-85px' }}> */}
              {/* <button style={{ }}>
                    <ModalExample3
                        hasTitle
                        info
                        infoText="Select source code staging project names:"
                        className="modal_md"
                      //  repos = {this.username}
                      // changeStagingprj ={repoCallback}
                        buttonLabel = "Add User"
                      //  setRepos = {setRepo}
                    >

                    </ModalExample3>
            </button> */}



            {/* </div>
          )} */}
        </div>
        <Footer />
      </div>
    );
  }
}

ManagementDFuser.propTypes = {
  username: PropTypes.string,
  usersList: PropTypes.array
};

export default injectIntl(ManagementDFuser);



// WEBPACK FOOTER //
// ./src/components/views/ManagementDFuser/index.js